/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { EmailTemplatesDestroyPathParams, EmailTemplatesDestroyResponse } from '../types/EmailTemplatesDestroy'

/**
 * DELETE /email-templates/:emailTemplate
 * @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::destroy
 */
export async function emailTemplatesDestroy(
	emailTemplate: EmailTemplatesDestroyPathParams['emailTemplate'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<EmailTemplatesDestroyResponse>> {
	return axiosInstance.delete(`/email-templates/${emailTemplate}`, config)
}
